import React from "react";

const Iccrda2025 = () => {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-10">
      <div className="mx-auto max-w-5xl">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-800">
            Previous Conference
          </h1>
          <p className="mt-2 text-xl font-semibold text-indigo-600">
            ICCRDA 2025
          </p>
          <hr className="mt-4 mx-auto w-48 border-2 border-indigo-600" />
        </div>

        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-md p-6 md:p-8 mb-10">
          <h2 className="text-2xl font-semibold text-slate-800 mb-4">
            International Conference on Computational Technologies for Research in Data Analytics (ICCTRDA-2025)
          </h2>

          <p className="text-base leading-relaxed text-slate-700">
            The International Conference on Computational Technologies for Research in Data Analytics
            (ICCTRDA-2025) was successfully held on 21–22 November 2025 at Duy Tan University,
            Da Nang, Vietnam. The conference fostered high-quality academic exchange and
            cutting-edge research discussions among pioneering researchers, scientists,
            academicians, industry experts, and students from across the globe.
          </p>

          <p className="mt-4 text-base leading-relaxed text-slate-700">
            ICCTRDA-2025 received more than <strong>1,200 paper submissions</strong> from
            <strong> 18 countries</strong>. After a rigorous peer-review process,
            <strong> 180 papers</strong> were accepted and registered, resulting in an
            acceptance ratio of <strong>15%</strong>. The accepted papers were published
            across four volumes of the prestigious <strong>Springer Lecture Notes on
            Networks and Systems (LNNS)</strong> series.
          </p>

          <p className="mt-4 text-base leading-relaxed text-slate-700">
            The conference was attended by a total of <strong>300 participants</strong>,
            including authors, keynote speakers, delegates, academicians, and industry
            professionals. Among them, <strong>40 participants attended in offline mode</strong>,
            while <strong>260 participants joined online</strong>, making the event a truly
            global and hybrid academic platform.
          </p>
        </div>

        {/* Proceedings */}
        <div className="bg-white rounded-2xl shadow-md p-6 md:p-8 mb-10">
          <h2 className="text-2xl font-semibold text-slate-800 mb-5">
            Conference Proceedings
          </h2>

          <div className="grid gap-4 sm:grid-cols-2">
            <a
              href="https://link.springer.com/book/9783032276650"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-xl border border-indigo-200 p-4 hover:border-indigo-500 hover:bg-indigo-50 transition"
            >
              <h3 className="font-semibold text-indigo-700">Volume 1</h3>
              <p className="mt-1 text-sm text-slate-600">
                Springer LNNS Proceedings
              </p>
            </a>

            <a
              href="https://link.springer.com/book/9783032276681"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-xl border border-indigo-200 p-4 hover:border-indigo-500 hover:bg-indigo-50 transition"
            >
              <h3 className="font-semibold text-indigo-700">Volume 2</h3>
              <p className="mt-1 text-sm text-slate-600">
                Springer LNNS Proceedings
              </p>
            </a>

            <a
              href="https://link.springer.com/book/9783032268976"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-xl border border-indigo-200 p-4 hover:border-indigo-500 hover:bg-indigo-50 transition"
            >
              <h3 className="font-semibold text-indigo-700">Volume 3</h3>
              <p className="mt-1 text-sm text-slate-600">
                Springer LNNS Proceedings
              </p>
            </a>

            <a
              href="https://link.springer.com/book/9783032256935"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-xl border border-indigo-200 p-4 hover:border-indigo-500 hover:bg-indigo-50 transition"
            >
              <h3 className="font-semibold text-indigo-700">Volume 4</h3>
              <p className="mt-1 text-sm text-slate-600">
                Springer LNNS Proceedings
              </p>
            </a>
          </div>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center text-center">
          <a
            href="/bestpapers/2025"
            className="inline-block rounded-lg border border-indigo-600 px-6 py-3 text-indigo-600 font-semibold hover:bg-indigo-600 hover:text-white transition"
          >
            View Best Papers – 2025
          </a>

          <a
            href="/awards/2025"
            className="inline-block rounded-lg border border-emerald-600 px-6 py-3 text-emerald-600 font-semibold hover:bg-emerald-600 hover:text-white transition"
          >
            Awards & Recognitions – 2025
          </a>
        </div>
      </div>
    </div>
  );
};

export default Iccrda2025;